/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Accesstoken1Inputs */

const de__field_accesstoken1 = /** @type {(inputs: _Field_Accesstoken1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token`)
};

/**

* @param {_Field_Accesstoken1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_accesstoken1 = /** @type {((inputs?: _Field_Accesstoken1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Accesstoken1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_accesstoken1(inputs)
});
export { _field_accesstoken1 as "_field_accessToken" }